import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAccessProjects, loadMoreProjects } from '../../../redux/customers/customersActions';

const useAccessProjectsOptions = (shouldIgnoreCompanyProjects = false) => {
  const dispatch = useDispatch();

  const [projectSearch, setProjectSearch] = useState('');
  const accessProjects = useSelector((state) => state.customers.accessProjects);

  const mappedAccessProjects = useMemo(
    () => accessProjects.map(({ id, projectName }) => ({ id, name: projectName })),
    [accessProjects],
  );

  const handleSearchProjects = useCallback(
    (newSearch) => {
      setProjectSearch(newSearch);
      dispatch(getAccessProjects({ page: 1, searchQuery: newSearch, shouldIgnoreCompanyProjects }));
    },
    [dispatch, shouldIgnoreCompanyProjects],
  );

  const handleLoadMoreProjects = useCallback(
    (newPage) => {
      dispatch(loadMoreProjects({ page: newPage, searchQuery: projectSearch, shouldIgnoreCompanyProjects }));
    },
    [dispatch, projectSearch, shouldIgnoreCompanyProjects],
  );

  useEffect(() => {
    dispatch(getAccessProjects({ page: 1, searchQuery: projectSearch, shouldIgnoreCompanyProjects }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldIgnoreCompanyProjects]);

  return useMemo(
    () => ({
      projectSearch,
      accessProjects: mappedAccessProjects,
      handleSearchProjects,
      handleLoadMoreProjects,
    }),
    [projectSearch, mappedAccessProjects, handleSearchProjects, handleLoadMoreProjects],
  );
};

export default useAccessProjectsOptions;
